<template>
  <div class="paper">

    <div v-if="!isRule" class="paper-main">
      <div class="contain">
        <div class="common">
          <!-- 搜索 -->
          <div class="top clearfix">
            <div class="fl">
              <span>搜索: </span>
              <el-input class="searchkey-input-com" placeholder="请输入关键字" v-model="searchKey" size="small"
                        @change="selectLsit(1)" clearable>
              </el-input>
              学年：
              <el-date-picker class="search-year" v-model="searchYear" value-format="yyyy" size="small" type="year"
                              @change="selectLsit(1)">
              </el-date-picker>
              学期： <el-select clearable v-model="searchTerm" size="small" @change="selectLsit(1)">
                <template v-for="i of dic.schoolTerm">
                  <el-option :key="i.id" :label="i.dicName" :value="i.dicCode"></el-option>
                </template>
              </el-select>

            </div>
            <div class="fr">
              <!-- 批量导入 -->
              <export-upload v-if="isAdmin" @selectLsit="exSelectLsit" :urlAction="exUrl"
                             :exData="exData"></export-upload>
              <el-button size="small" @click="dowTemplate" v-if="isAdmin">模板下载</el-button>
              <el-button size="small" icon="iconfont icon-daochu" @click="importTeacher" v-if="isAdmin">导出</el-button>
              <!-- <el-button
                size="small"
                icon="iconfont icon-add"
                @click="showAddPop"
              >新增</el-button> -->
              <icon-integral-rule :isRule="isRule" @openRule="isRule = true"></icon-integral-rule>
            </div>
          </div>
          <!-- 表格 -->
          <el-table element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 255, 255, 0.9)" v-loading="isTableLoading" row-key="id"
                    :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#EFEFEF' }">
            <el-table-column prop="schoolYear" label="学年" width="60">
            </el-table-column>
            <el-table-column prop="schoolTermDesc" label="学期" width="100">
            </el-table-column>
            <el-table-column prop="teacherName" label="教师名称">
            </el-table-column>
            <el-table-column prop="examineItem" label="考核项目">
            </el-table-column>
            <el-table-column prop="checkRankDesc" label="等第">
            </el-table-column>
            <el-table-column prop="checkScore" label="分数">
            </el-table-column>
            <el-table-column prop="score" label="获得积分">
            </el-table-column>
            <el-table-column v-if="isAdmin" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" class="text-edit" @click="showEdit(scope.$index, scope.row)">编辑</el-button>|
                <el-button type="text" class="text-del" @click="showDelPop(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange"
                      @handleCurrentChange="handleCurrentChange"></pagination>
          <!-- 删除的对话框 -->
          <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>

          <!--新增的对话框 -->
          <el-dialog class="add-pop" :visible.sync="addVisible" :close-on-click-modal="false" width="40%" top="5%">
            <template v-slot:title>
              <div class="add-title">{{ form.id ? "编 辑" : "新 增" }} </div>
            </template>
            <!-- 对话框内容部分 => 匿名插槽 -->
            <el-form ref="form" :rules="rules" :model="form" label-width="130px">
              <el-form-item label="学年" prop="schoolYear">
                <el-date-picker class="width-form-input" v-model="form.schoolYear" value-format="yyyy" type="year"
                                placeholder="请选择">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="学期" prop="schoolTerm">
                <el-select v-model="form.schoolTerm" placeholder="请选择">
                  <template v-for="i of dic.schoolTerm">
                    <el-option :key="i.id" :label="i.dicName" :value="i.dicCode"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <!-- 教师姓名 -->
              <el-form-item label="教师姓名" prop="teacherId">
                <el-select v-model="form.teacherId" filterable remote reserve-keyword placeholder="请输入教师姓名关键字"
                           :remote-method="teacherKeyChange" :loading="teacherLoading">
                  <el-option v-for="item in teacherOptions" :key="item.id"
                             :label="item.teacherNum ? (item.userName + '(师训号:' + item.teacherNum + ')') : item.userName"
                             :value="item.userId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="等第" prop="ruleList">
                <el-cascader @change="getIntegralNum" class="width-form-input" :props="defaultProps"
                             v-model="form.ruleList" :options="ruleOptions"></el-cascader>
              </el-form-item>
              <el-form-item label="分数" prop="checkScore">
                <el-input placeholder="请输入" @input="checkScoreInput" v-model="form.checkScore"></el-input>
              </el-form-item>
            </el-form>

            <template v-slot:footer>
              <span class="dialog-footer">
                <el-button @click="submitStudent" type="primary">提 交</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </div>
    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";
import IconIntegralRule from "@/components/IconIntegralRule.vue";
import IntegralRuleView from "@/components/IntegralRuleView.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import ExportUpload from "@/components/ExportUpload.vue";
import { teacherKeyChange, exportExecl, downloadExecl, clearNoNum } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
export default {
  mixins: [mixin],
  components: {
    Breadcrumb,
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    ExportUpload,
    Upload,
    Pagination,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
      "ruleOptions",
      "ruleOptionsList"
    ]),
    exData() {
      return {
        integralModel: this.menuCodeMix,
        schoolCode: this.userInfo.schoolCode,
      };
    },
  },
  data() {
    return {
      exUrl: "/imp/impResearchCheckScoreInfo",
      searchKey: "",
      form: {
        id: "",
        checkDate: "",
        checkRank: "", //等第
        checkScore: "",
      },

      rules: {
        checkScore: [
          {
            required: true,
            message: "请输入分数",
            trigger: ["change", "blur"],
          },
        ],
        ruleList: [
          {
            required: true,
            message: "请输入等第",
            trigger: ["change", "blur"],
          },
        ],
      },
    };
  },
  methods: {
    checkScoreInput() {
      this.form.checkScore = clearNoNum(this.form.checkScore)
    },
    //批量导入成功后
    exSelectLsit() {
      this.selectLsit(1);
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        keyword: this.searchKey || "",
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        isAdmin: this.isAdmin / 1 ,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/teacherResearch/getResearchCheckScoreList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "数据获取失败",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //模板下载
    dowTemplate() {
      downloadExecl("/tmp/ddResearchCheckScoreInfo", "教育教学质量-模板-" + this.userInfo.userName,);
    },
    //导出
    importTeacher() {
      exportExecl(
        "/exp/expResearchCheckScoreInfo",
        "教育教学质量-" + this.userInfo.userName,
        this.userInfo.schoolCode,
        this.pageObj.current,
        this.pageObj.size,
        this.searchYear,
        this.searchTerm,
        this.searchKey
      );
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          let del = {
            clientPackage: "com.xueduoduo.teacher.archives.pc",
            id: this.selectRow.id,
            operatorId: this.userInfo.userId,
          };
          let { resultCode, msg } = await this.$axios.post(
            "/teacherResearch/deleteTeacherResearchCheckScore",
            del
          );
          if (resultCode === 200) {
            this.selectLsit(this.pageObj.current, this.pageObj.size),
              this.$message.success("删除成功");
          } else {
            this.$message.error(msg);
          }
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    //编辑
    showEdit(index, row) {
      this.selectRow = row;
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);
      this.form = {
        id: row.id,
        schoolYear: row.schoolYear + "",
        schoolTerm: row.schoolTerm + "",
        ruleList: [row.checkRank],
        score: row.score,
        teacherId: row.teacherId,
        teacherName: row.teacherName,

        checkDate: row.checkDate,
        checkRank: row.checkRank, //等第
        checkScore: row.checkScore,
      };
      this.isInclude(this.ruleOptionsList, this.form.ruleList) ? "" : (this.form.ruleList = []);
      this.getIntegralNum();
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            this.form.checkRank = this.form.ruleList[0];
            this.$axios
              .post(
                "/teacherResearch/updateTeacherResearchCheckScore",
                this.form
              )
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            console.log("保存");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../styles/common.less";

.searchkey-input-com {
  width: 25%;
  margin-right: 15px;
}
</style>


